<template>
  <div class="page">
    <div class="container">
      <div class="page-title">
        <el-page-header
          content="编辑商品"
          @back="$router.back()"
        ></el-page-header>
      </div>
      <div class="content">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
          class="edit-form"
        >
          <el-form-item label="商品种类" prop="category" required>
            <el-select v-model="ruleForm.category" placeholder="请选择商品种类">
              <el-option label="伴学精灵" :value="0"></el-option>
              <el-option label="头像挂件" :value="1"></el-option>
              <!-- <el-option label="实物" :value="2"></el-option> -->
              <el-option label="头像" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <!-- 创建的时候没有，自动生成，编辑的时候能看到并且disabled -->
          <el-form-item
            label="商品编号"
            prop="productNumber"
            class="is-required"
          >
            <el-input v-model="ruleForm.productNumber" disabled></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="name" required>
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="排序号" prop="sort" required>
            <!-- step-strictly  @change="handleChange"-->
            <el-input-number
              v-model="ruleForm.sort"
              :precision="1"
              :step="0.1"
              controls-position="right"
              :min="0"
              :max="Infinity"
              label="请输入排序号"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="商品实际图" prop="pictureUrl" required>
            <el-upload
              action=""
              :on-remove="handleRemove"
              :on-change="handleChangeFile"
              :auto-upload="false"
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="fileList"
              list-type="picture-card"
              style="width: 400px"
            >
              <i class="el-icon-plus"></i>
              <!-- <el-button size="mini" type="primary" plain>点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div> -->
            </el-upload>
          </el-form-item>
          <el-form-item label="商品预览图" required prop="highPictureUrl">
            <el-upload
              action=""
              :on-remove="handleRemove2"
              :on-change="handleChangeFile2"
              :auto-upload="false"
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="fileList2"
              list-type="picture-card"
              style="width: 400px"
            >
              <i class="el-icon-plus"></i>
              <!-- <el-button size="mini" type="primary" plain>点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div> -->
            </el-upload>
          </el-form-item>
          <el-form-item
            label="提示词"
            prop="cueWord"
            required
            v-if="ruleForm.category === 0"
          >
            <el-input v-model="ruleForm.cueWord"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="cancelForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { adminTmplProductEdit } from '@/api/javaApi'
import uploadFile from '@/config/uploadFile'

export default {
  name: 'goodsAdd',
  data: () => ({
    uploadFileTime: false,
    fileList: [],
    fileList2: [],
    ruleForm: {
      category: 0, // 商品类型（0为头像，1为头衔
      productNumber: '', // 商品编号：创建时没有，自动生成，编辑的时候显示并且禁用
      name: '', // 商品名称
      pictureUrl: '', // 商品实际图地址
      highPictureUrl: '', // 商品预览图片地址
      starNum: '', // 兑换星币数
      inventory: '', // 库存
      creator: '', // 创建者
      updater: '', // 更新者
      sort: '',
      cueWord: '', // 提示词
    },
    rules: {
      name: [
        { required: true, message: '请输入商品名称', trigger: 'blur' },
        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
      ],
      pictureUrl: [
        { required: true, message: '请上传商品实际图', trigger: 'change' },
      ],
      highPictureUrl: [
        { required: true, message: '请上传商品预览图', trigger: 'blur' },
      ],
      starNum: [
        { required: true, message: '请输入兑换星币数量', trigger: 'blur' },
        { min: 1, max: 11, message: '长度在 1 到 11 个位', trigger: 'blur' },
      ],
      inventory: [
        { required: true, message: '请输入库存数量', trigger: 'blur' },
        { min: 1, max: 11, message: '长度在 1 到 11 个位', trigger: 'blur' },
      ],
      sort: [
        { required: true, message: '请输入排序号', trigger: 'blur' },
        // { min: 1, max: 11, message: '长度在 1 到 11 个位', trigger: 'blur' },
      ],
      cueWord: [
        { required: true, message: '请输入提示词', trigger: ['blur', 'input'] },
        // { min: 1, max: 11, message: '长度在 1 到 11 个位', trigger: 'blur' },
      ],
    },
  }),
  created() {
    console.log(this.$store.state)
    const routeParams = this.$route.query
    if (routeParams) {
      this.ruleForm.category = Number(routeParams.category)
      this.ruleForm.name = routeParams.name
      this.ruleForm.productNumber = routeParams.productNumber
      this.ruleForm.sort = Number(routeParams.sort)
      this.ruleForm.cueWord = routeParams.cueWord
      this.fileList = [
        {
          url:
            // this.$store.state.resource.picBaseUrl +
            (this.ruleForm.pictureUrl = routeParams.pictureUrl),
        },
      ]
      this.fileList2 = [
        {
          url:
            // this.$store.state.resource.picBaseUrl +
            (this.ruleForm.highPictureUrl = routeParams.highPictureUrl),
        },
      ]
    }
  },
  methods: {
    submitForm(formName) {
      this.ruleForm.creator = this.$store.state.user.userInfo.id
      this.ruleForm.updater = this.$store.state.user.userInfo.id
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          this.adminTmplProductEdit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.back()
    },
    handleSizeChange(size) {
      this.page_size = size
      this.page_no = 1
    },
    handleCurrentChange(page) {
      this.page_no = page
    },
    async adminTmplProductEdit() {
      const params = {
        id: this.$route.query.id,
        updater: this.$store.state.user.userInfo.id,
      }
      if (this.ruleForm.category !== Number(this.$route.query.category)) {
        params.category = this.ruleForm.category
      }
      if (this.ruleForm.name !== this.$route.query.name) {
        params.name = this.ruleForm.name
      }
      if (this.ruleForm.pictureUrl !== this.$route.query.pictureUrl) {
        params.pictureUrl = this.ruleForm.pictureUrl
      }
      if (this.ruleForm.highPictureUrl !== this.$route.query.highPictureUrl) {
        params.highPictureUrl = this.ruleForm.highPictureUrl
      }
      if (this.ruleForm.sort !== Number(this.$route.query.sort)) {
        params.sort = this.ruleForm.sort
      }
      if (this.ruleForm.cueWord !== this.$route.query.cueWord) {
        params.cueWord = this.ruleForm.cueWord
      }
      if (this.ruleForm.category !== 0) {
        params.cueWord = null
      }
      const res = await adminTmplProductEdit(params)
      console.log(res)
      if (res) this.$message.success(res)
      this.$refs['ruleForm'].resetFields()
      this.$router.back()
    },

    // 共用
    handleExceed() {
      this.$message.warning(`只能上传1张图片，请删除后重新上传！`)
    },
    // 第一个 pictureUrl的
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log(res)
          this.fileList = res
          if (res && res.length > 0) {
            this.ruleForm.pictureUrl = res[0].name
          }
          this.uploadFileTime = false
        }
      )
    },
    // 第二个 highPictureUrl的
    handleRemove2(file, fileList) {
      this.fileList2 = fileList
    },

    async handleChangeFile2(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss2(fileList)
      }
    },
    async uploadFileOss2(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log(res)
          this.fileList2 = res
          if (res && res.length > 0) {
            this.ruleForm.highPictureUrl = res[0].name
          }
          this.uploadFileTime = false
        }
      )
    },
  },
}
</script>
<style scoped lang="scss">
.page {
  display: flex;
  width: 100%;
  min-height: 100%;
  padding: 10px;
  box-sizing: border-box;
  .container {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;
    // height: 100%;
    min-height: 100%;
    padding: 40px 20px 20px;
    background-color: #fff;
    border-radius: 5px;
    .page-title {
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;
    }
    .content {
      padding-top: 20px;
      .edit-form {
        width: 500px;
      }
    }
  }
}
</style>
